import React, { useState } from 'react';
import { PiEyeClosedBold } from 'react-icons/pi';
import { FaEye } from 'react-icons/fa6';
import PropTypes from 'prop-types';

const InputPassword = ({ name, value, onChange, required, id, autoFocus, ...rest }) => {
  const [isPass, setIsPass] = useState(true);
  return (
    <div className='input-group'>
      <input
        type={isPass ? 'password' : 'text'}
        className='form-control'
        name={name}
        value={value}
        onChange={onChange}
        required={required}
        id={id}
        autoFocus={autoFocus}
        {...rest}
      />
      <div className='input-group-append'>
        <button
          type='button'
          onClick={() => setIsPass((prev) => !prev)}
          className='input-group-text'
          autoComplete='off'
        >
          {isPass ? <PiEyeClosedBold /> : <FaEye />}
        </button>
      </div>
    </div>
  );
};

InputPassword.defaultProps = {
  value: '',
  onChange: () => {},
  required: false,
  id: '',
  autoFocus: false,
};

InputPassword.propTypes = {
  name: PropTypes.string.isRequired,
  value: PropTypes.string,
  onChange: PropTypes.instanceOf(Function),
  required: PropTypes.bool,
  id: PropTypes.string,
  autoFocus: PropTypes.bool,
};

export default InputPassword;
